export default __webpack_public_path__ + "static/media/logo-white.7a7c8f35.svg";